var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-list"
  }, _vm._l((_vm.articles), function(article, i) {
    return _c('article', {
      key: article.id,
      staticClass: "article",
      class: {
        featured: i === 0,
          standard: i !== 0,
          unneeded: i === _vm.articles.length - 1,
      }
    }, [_c('a', {
      staticClass: "article-link",
      attrs: {
        "href": article.url
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "article-image",
      attrs: {
        "src": article.image,
        "loading": "lazy"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "article-text"
    }, [_c('h3', {
      staticClass: "article-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), [(i === 0) ? _c('CmTruncatedText', {
      staticClass: "article-excerpt"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(article.excerpt)
      }
    })]) : _c('p', {
      staticClass: "article-excerpt",
      domProps: {
        "innerHTML": _vm._s(article.excerpt)
      }
    })], _vm._v(" "), _c('div', {
      staticClass: "cta-link"
    }, [_vm._v("Read more")])], 2)])
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30962e94","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-articles.vue
// module id = null
// module chunks = 